import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import repayApi from "./repayApi";

export const getRepayment = createThunkFromApi(
  "repay/getRepayment",
  repayApi.getRepayment
);

export const getRepaymentAmountMax = createThunkFromApi(
  "repay/getRepaymentAmountMax",
  repayApi.getRepaymentAmountMax
);

export const repaymentInsert = createThunkFromApi(
  "repay/repaymentInsert",
  repayApi.repaymentInsert
);

const initialState = {
  repayAmountMax: null,
  repayInitial: null
};

export const repaySlice = createSlice({
  name: "repay",
  initialState,

  extraReducers: {
    [getRepayment.fulfilled]: (state, { payload }) => {
      state.repayInitial = payload.data;
    },
    
    [getRepaymentAmountMax.fulfilled]: (state, { payload }) => {
      state.repayAmountMax = payload.data;
    },
  }
});

export default repaySlice.reducer;
